class DataController {
  async getData (url: string, redirect: RequestRedirect = 'follow') {
    try {
      const response = await fetch(new Request(url, {redirect: redirect}))
      const json = await response.json()
      this.handleErrors(response)
      return json
    }
    catch {
      return
    }
  }

  async getDataHtml (url: string) {
    try {
      const response = await fetch(url);
      const html = await response.text();
      this.handleErrors(response);
      return html;
    }
    catch(err) {
      console.error("ERROR:", err);
    }
  }

  async postData (url: string, data?: FormData) {
    try {
      const response = await fetch(url, {
        method: "POST",
        body: data
      });
      const json = await response.json();
      this.handleErrors(response);
      return json;
    }
    catch(err) {
      console.error("ERROR:", err);
    }
  }


  handleErrors (response) {
    if (!response.ok) {
      throw new Error(response.statusText);
    }
  }
}

export const DataService = new DataController();
